import runAfterDelayPerformanceUtil from 'modules/performance/run-after-delay/index.js'

/**
 * @param options
 * @param options.delay
 * @returns {Promise<unknown>}
 */
export default function runAfterDelayPromisifiedPerformanceUtil (options) {
  return new Promise(resolve => {
    runAfterDelayPerformanceUtil(resolve, options)
  })
}
